<template>
  <div :class="['rounded-l-2large mx-2 pb-16']">
    <div class="mb-4">
      <h2
        :class="[
          'text-xl flex justify-begin justify-center mt-4',
          theme.body.primaryColor,
        ]"
      >
        {{ lang["my_order"][language] }}
      </h2>
    </div>
    <div>
      <table class="w-full text-sm lg:text-base mb-10" cellspacing="0">
        <transition-group name="list" tag="tbody" mode="out-in">
          <div
            v-for="(cartItem, index) in $_.uniqWith(cartItems, $_.isEqual)"
            :key="index"
            :class="[
              'rounded-large flex h-16 items-center mb-2 p-2 h-full shadow-lg transition duration-500  hover:shadow-xl',
              theme.addToCart.backgroundColor,
              backgroundColor ? theme.middleScreen.backgroundColor : '',
            ]"
          >
            <td v-show="!backgroundColor" class="w-1/5 justify-center flex">
              <img
                v-if="cartItem.pictureUrl"
                :src="cartItem.pictureUrl"
                class="w-10 h-10 rounded-lg rouned-lg ml-4"
                alt
                z-0
              />
            </td>
            <td class="text-left md:table-cell w-3/5 m-1 h-full">
              <p
                :class="[
                  'text-sm lg:text-base font-medium',
                  theme.body.textColor,
                ]"
              >
                <small class="text-primary-light"></small>
                {{ cartItem[`name_${language}`] }}
              </p>
              <div>
                <small
                  :class="[theme.body.textColor]"
                  v-for="(additionGroup, index) in cartItem.OrderItemAdditions"
                  :key="additionGroup['AdditionGroup']['id']"
                >
                  {{ additionGroup["Addition"][`name_${language}`] }}
                  <span v-if="additionGroup['Addition']['price'] != 0">
                    (+{{
                      new Intl.NumberFormat(languageLocales[language].locale, {
                        style: "currency",
                        currency: languageLocales[language].currency,
                      })
                        .formatToParts(additionGroup["Addition"]["price"])
                        .map(({ type, value }) => {
                          switch (type) {
                            case "currency":
                              return `${currency}`;
                            default:
                              return value;
                          }
                        })
                        .reduce((string, part) => string + part)
                    }})
                  </span>
                  <label
                    :class="[theme.body.textColor]"
                    v-if="index + 1 < cartItem.OrderItemAdditions.length"
                    >•</label
                  >
                </small>
              </div>
            </td>
            <td :class="['w-1/7 justify-begin flex', theme.body.textColor]">
              x{{ $_.countBy(cartItems, cartItem).true }}
            </td>
            <td class="text-right md:table-cell w-1/4">
              <span
                :class="[
                  'text-sm lg:text-base font-medium',
                  theme.body.textColor,
                ]"
              >
                {{
                  new Intl.NumberFormat(languageLocales[language].locale, {
                    style: "currency",
                    currency: languageLocales[language].currency,
                  })
                    .formatToParts(cartItem.price)
                    .map(({ type, value }) => {
                      switch (type) {
                        case "currency":
                          return `${currency}`;
                        default:
                          return value;
                      }
                    })
                    .reduce((string, part) => string + part)
                }}
              </span>
            </td>
            <div class="flex w-1/6 justify-end mr-1">
              <div>
                <div>
                  <a @click.prevent="removeItem(cartItem)">
                    <svg
                      :class="[
                        'fill-current inline-block h-6 w-6 rounded-full cursor-pointer',
                        theme.addToCart.deleteButtonTextColor,
                      ]"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </transition-group>
      </table>
      <div>
        <div
          :class="[
            'mx-2 border-t-2 border-dashed border-' + theme.body.primaryColor,
          ]"
        >
          <div
            :class="[
              'flex justify-between pt-4 items-center mr-4',
              theme.body.primaryColor,
            ]"
          >
            <div
              :class="['text-lg font-bold text-center ' + theme.body.textColor]"
            >
              {{ lang["total"][language] }}
            </div>
            <div :class="['font-bold text-center', theme.body.textColor]">
              {{ cartValue }}
            </div>
          </div>
          <div
            v-show="this.menu.enable_tipping"
            :class="[
              'flex justify-between pt-4 items-center ',
              theme.body.primaryColor,
            ]"
          >
            <div :class="['font-bold text-center', theme.body.textColor]">
              {{ lang["tip"][language] }}
            </div>
            <div
              :class="[
                'font-bold text-center flex justify-end',
                theme.body.textColor,
              ]"
            >
              <div
                :class="[
                  'flex flex-row h-8 rounded-lg relative bg-transparent justify-center items-center rounded-2large border-white w-2/5',
                  theme.addToCart.backgroundColorPlus,
                ]"
              >
                <button
                  @click.stop="removeFromTipAmount()"
                  :class="[
                    theme.addToCart.backgroundColorPlus,
                    'fill-current focus:outline-none inline-block h-6 w-6 rounded-full m-2',
                    theme.addToCart.textColorPlus,
                  ]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M20 12H4"
                    />
                  </svg>
                </button>
                <input
                  type="number"
                  readonly
                  :class="[
                    theme.body.backgroundColor,
                    theme.body.textColor,
                    'focus:outline-none text-center h-8 w-6 text-md md:text-basecursor-default flex items-center outline-none w-full justify-center',
                  ]"
                  name="tip"
                  :value="this.tipAmount"
                />
                <button
                  @click.stop="addToTipAmount()"
                  :class="[
                    theme.addToCart.backgroundColorPlus,
                    'h-6 w-6 rounded-full cursor-pointer focus:outline-none m-2',
                    theme.addToCart.textColorPlus,
                  ]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div
            :class="[
              'flex justify-between pt-4 items-center',
              theme.body.primaryColor,
            ]"
            v-if="this.menu.is_discounts_enabled"
          >
            <div
              :class="['text-lg font-bold text-center ' + theme.body.textColor]"
            >
              {{ lang["discount"][language] }}
            </div>
            <input
              name="discountCode"
              :class="[
                'appearance-none block rounded-lg py-3 px-4 leading-tight focus:outline-none shadow-lg transition duration-500 hover:shadow-xl text-black bg-white ml-6 text-center w-68 ',
                discountCode
                  ? discountInfo.value
                    ? 'border border-green-300'
                    : 'border border-red-500'
                  : '',
              ]"
              id="discountCode"
              type="text"
              placeholder="PROMO2021"
              v-on:input="addDiscountCode($event)"
              :value="discountCode"
            />
          </div>

          <div
            :class="[
              'flex justify-between pt-4 text-left',
              theme.body.primaryColor,
            ]"
            v-if="discountInfo.description"
          >
            {{ discountInfo.description }}
          </div>

          <div
            :class="[
              'flex justify-between pt-4 items-center',
              theme.body.primaryColor,
            ]"
            v-if="
              cartItems.length >= discountInfo.minimum_items &&
              totalPriceValue + tipAmount >= discountInfo.minimum_spent
            "
          >
            <div
              :class="['text-lg font-bold text-center ' + theme.body.textColor]"
            >
              {{ lang["discount_amount"][language] }}
            </div>
            <div
              v-if="discountInfo.type != 'Percentage'"
              :class="['font-bold text-center mr-4', theme.body.textColor]"
            >
              -
              {{
                new Intl.NumberFormat(languageLocales[language].locale, {
                  style: "currency",
                  currency: languageLocales[language].currency,
                })
                  .formatToParts(discountAmount)
                  .map(({ type, value }) => {
                    switch (type) {
                      case "currency":
                        return `${currency}`;
                      default:
                        return value;
                    }
                  })
                  .reduce((string, part) => string + part)
              }}
            </div>
            <div
              v-else
              :class="['font-bold text-center mr-4', theme.body.textColor]"
            >
              {{ discountInfo.value }}% = -{{
                new Intl.NumberFormat(languageLocales[language].locale, {
                  style: "currency",
                  currency: languageLocales[language].currency,
                })
                  .formatToParts(discountAmount)
                  .map(({ type, value }) => {
                    switch (type) {
                      case "currency":
                        return `${currency}`;
                      default:
                        return value;
                    }
                  })
                  .reduce((string, part) => string + part)
              }}
            </div>
          </div>
          <div
            v-if="discountCode != '' && !discountInfo.value"
            :class="['flex justify-between pt-4 items-center mr-4']"
          >
            <div :class="['text-left', theme.body.textColor]">
              {{ lang["discount_invalid_code"][language] }}
            </div>
          </div>
          <div
            v-show="
              totalPriceValue + tipAmount < this.menu.min_spent_amount_w_charg
            "
            :class="[
              'flex justify-between pt-4 items-center',
              theme.body.primaryColor,
            ]"
          >
            <div
              :class="['text-lg font-bold text-center', theme.body.textColor]"
            >
              {{ lang["fee"][language] }}
              <!-- (Amount under
              {{ this.menu.min_spent_amount_w_charg }}) -->
            </div>
            <div :class="['font-bold text-center mr-4', theme.body.textColor]">
              {{
                new Intl.NumberFormat(languageLocales[language].locale, {
                  style: "currency",
                  currency: languageLocales[language].currency,
                })
                  .formatToParts(this.menu.charge_amount_when_min_spent)
                  .map(({ type, value }) => {
                    switch (type) {
                      case "currency":
                        return `${currency}`;
                      default:
                        return value;
                    }
                  })
                  .reduce((string, part) => string + part)
              }}
            </div>
          </div>

          <div
            :class="[
              'flex justify-between pt-4 text-left',
              theme.body.primaryColor,
            ]"
            v-if="discountInfo.description"
          >
            {{ discountInfo.description }}
          </div>

          <div
            :class="[
              'flex justify-between pt-4 items-center mr-4',
              theme.body.primaryColor,
            ]"
            v-show="this.menu.enable_delivery==true && this.menu.pos_mode=='take-out'"
          >
            <div
              :class="['text-lg font-bold text-center ' + theme.body.textColor]"
            >
              {{ lang["Delivery"][language] }}
            </div>
            <div :class="['font-bold text-center', theme.body.textColor]">
              <div class="flex items-center justify-center w-full">
                <label for="toogleA" class="flex items-center cursor-pointer">
                  <div class="relative">
                    <input
                      id="toogleA"
                      type="checkbox"
                      class="hidden"
                      :checked="homeDelivery"
                      @click="HomeDeliveryToggle()"
                    />
                    <div
                      class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                    ></div>
                    <div
                      class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                    ></div>
                  </div>
                </label>
              </div>
            </div>
          </div>

          <div
            :class="[
              'flex justify-between pt-4 items-center mr-4',
              theme.body.primaryColor,
            ]"
            v-show="homeDelivery"
          >
            <div
              :class="['text-lg font-bold text-center ' + theme.body.textColor]"
            >
              {{ lang["DeliveryCosts"][language] }}
            </div>
            <div :class="['font-bold text-center', theme.body.textColor]">
              {{
                new Intl.NumberFormat(languageLocales[language].locale, {
                  style: "currency",
                  currency: languageLocales[language].currency,
                })
                  .formatToParts(homeDeliveryCosts)
                  .map(({ type, value }) => {
                    switch (type) {
                      case "currency":
                        return `${currency}`;
                      default:
                        return value;
                    }
                  })
                  .reduce((string, part) => string + part)
              }}
            </div>
          </div>

          <div
            :class="[
              'border-t-2 border-dashed mt-2 border-' + theme.body.primaryColor,
            ]"
          ></div>

          <div
            :class="[
              'flex justify-between pt-4 items-center mr-4',
              theme.body.primaryColor,
            ]"
          >
            <div
              :class="['text-lg font-bold text-center ' + theme.body.textColor]"
            >
              {{ lang["total"][language] }}
            </div>
            <div :class="['font-bold text-center', theme.body.textColor]">
              {{ totalPriceValueWithCosts }}
            </div>
          </div>
          <div
            v-if="
              totalPriceValue + tipAmount < this.menu.min_spent_amount
            "
            :class="['flex justify-between pt-4 items-center mr-4']"
          >
            <div :class="['text-left', theme.body.textColor]">
              {{ lang["information"][language] }}{{ currency }}
              {{ this.menu.min_spent_amount
              }}{{ lang["information_extra"][language] }}{{ currency }}
              {{ this.menu.charge_amount_when_min_spent }}.
            </div>
          </div>
          <div
            v-else-if="totalPriceValue + tipAmount < this.menu.min_spent_amount"
            :class="['text-left mt-4', theme.body.textColor]"
          >
            {{ lang["information"][language] }}{{ currency
            }}{{ this.menu.min_spent_amount
            }}{{ lang["information_extra_extra"][language] }}
          </div>
          <div
            v-if="
              discountInfo.type == 'Percentage' &&
              discountAmount >= discountInfo.max_disc_amount_percentage &&
              discountInfo.max_disc_amount_percentage !== 0
            "
            :class="['flex justify-between pt-4 items-center mr-4']"
          >
            <div :class="['text-left', theme.body.textColor]">
              {{ lang["discount_max_reached"][language] }}{{ currency }}
              {{ discountInfo.max_disc_amount_percentage }}
            </div>
          </div>
          <div
            v-if="discountInfo && cartItems.length < discountInfo.minimum_items"
            :class="['flex justify-between pt-4 items-center mr-4']"
          >
            <div :class="['text-left', theme.body.textColor]">
              {{ lang["discount_low_items"][language] }}
              {{ discountInfo.minimum_items }} {{ lang["items"][language] }}
            </div>
          </div>

          <div
            v-if="
              discountInfo &&
              totalPriceValue + tipAmount < discountInfo.minimum_spent
            "
            :class="['flex justify-between pt-4 items-center mr-4']"
          >
            <div :class="['text-left', theme.body.textColor]">
              {{ lang["discount_min_price"][language] }}{{ currency }}
              {{ discountInfo.minimum_spent }}.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import lang from "../lang";
import { mapGetters, mapState } from "vuex";
import _ from "lodash";
export default {
  props: {
    backgroundColor: String,
  },
  data() {
    return {
      lang: lang,
    };
  },
  computed: {
    ...mapGetters(["currency", "language", "menuHash", "theme", "menu"]),
    ...mapGetters("Cart", [
      "cartItems",
      "cartValue",
      "totalPriceValue",
      "tipAmount",
      "totalPriceValueWithCosts",
      "totalPriceValueWithCostsValue",
      "discountAmount",
      "isDiscountCodeCorrect",
      "discountPercentageValue",
      "discountInfo",
      "discountCode",
      "homeDelivery",
      "homeDeliveryCosts"
    ]),
    ...mapState(["languageLocales"]),
  },
  methods: {
    HomeDeliveryToggle() {
      this.$store.commit("Cart/updateHomeDelivery");
    },
    removeItem(item) {
      this.$store
        .dispatch("Cart/UPDATE_ORDER", { operation: "remove", item: item })
        .then(() => {})
        .catch(() => {});
    },
    removeFromTipAmount() {
      this.$store.commit("Cart/updateTipAmount", -1);
    },
    addToTipAmount() {
      this.$store.commit("Cart/updateTipAmount", 1);
    },

    addDiscountCode: _.debounce(function (event) {
      this.$store.commit("Cart/updateDiscountCode", event.target.value);
      this.$store.dispatch("Cart/VALIDATE_DISCOUNT_CODE", event.target.value);
    }, 1000),
  },
  mounted() {
    if (!this.menuHash) {
      this.$store.commit("updateMenuHash", this.$route.params.menuHash);
    }
  },
};
</script>
<style scoped>
.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(30px);
}
</style>